export default "__VITE_ASSET__2819ea26__"